import { defineComponent as _defineComponent } from 'vue'
import { useChatStore } from '@/components/common/chat/useChatData'
import { computed } from 'vue'
import { useGetters } from 'vuex-composition-helpers'


export default /*#__PURE__*/_defineComponent({
  __name: 'Settings',
  setup(__props) {

const NEW_CHAT_NOTIFICATION_AUDIO = new Audio(
  require('../../assets/polite_alert.mp3')
)
const NEW_JOB_NOTIFICATION_AUDIO = new Audio(
  require('../../assets/message.mp3')
)

const store = useChatStore()

const { hasChatAccess, hasNotificationAccess } = useGetters('permissions', [
  'hasChatAccess',
  'hasNotificationAccess',
])

const jobAudibleAlert = computed(() => store.jobAudibleAlert)
const chatAudibleAlert = computed(() => store.chatAudibleAlert)

const jobVolumeIcon = computed(() => {
  return jobAudibleAlert.value ? 'volume_up' : 'volume_off'
})

const chatVolumeIcon = computed(() => {
  return chatAudibleAlert.value ? 'volume_up' : 'volume_off'
})

const chatAudibleAlertModel = computed({
  get() {
    return chatAudibleAlert.value
  },
  set(value) {
    store.updateChatAudibleAlert(value)
  },
})

const jobAudibleAlertModel = computed({
  get() {
    return jobAudibleAlert.value
  },
  set(value) {
    store.updateJobAudibleAlert(value)
  },
})

const playChatAudioSample = () => {
  NEW_CHAT_NOTIFICATION_AUDIO.play()
}
const playJobAudioSample = () => {
  NEW_JOB_NOTIFICATION_AUDIO.play()
}

return { __sfc: true,NEW_CHAT_NOTIFICATION_AUDIO, NEW_JOB_NOTIFICATION_AUDIO, store, hasChatAccess, hasNotificationAccess, jobAudibleAlert, chatAudibleAlert, jobVolumeIcon, chatVolumeIcon, chatAudibleAlertModel, jobAudibleAlertModel, playChatAudioSample, playJobAudioSample }
}

})